import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

/**
 * Bietet Navigation zu bestimmten Portalseiten an ohne dass der Aufrufende Kenntnis über die Struktur des Portals haben muss.
 * Die Implementierung dieses Interfaces erfolgt im portal-ui. Portalkomponenten kennen nur dieses Interface.
 */
@Injectable()
export abstract class IPortalNavigationService {

    /**
     * Navigiert zur Landing-Page des aktuellen Portalmoduls.
     */
    public navigateToLandingPage() { /** Mit Absicht leer. */
    }

    /**
     * Navigiert zu einer Portalseite. Die Struktur der URL muss /portalModul/pfad/zur/Seite?seitenparameter sein.
     */
    public navigate(portalUrl: string | string[], params?: {}) { /** Mit Absicht leer. */
    }

    /**
     * Erzeugt die externe URL zu einem Portal-Link. Kann z.B. verwendet werden, um das href-Attribut eines Links zu setzen,
     * damit dieser auch vom Benutzer in einem neuen Tab geöffnet werden kann.
     * Da der Links sich ändern kann bzw. berechnet werden muss (z.B. Login-Link mit Nonce), wird ein Observable zurückgegeben.
     */
    public getExternalUrl(portalUrl: string | string[], params?: {}): Observable<string> {
        return of('/dummy/');
    }
}
